@if (isCreatingCharacter()) {
  <app-loading-component
    [flavorTextOptions]="[
      'Inscribing your hero into the campaign ledger.',
      'Forging a fresh adventurer for this universe.',
      'Binding your new character to the party roster.'
    ]"
  />
} @else {
  <section class="page-card character-create-card">
    <app-back-button-component />

    <h2 class="section-title">Create Character</h2>
    <p class="empty-copy">
      Shape a new adventurer for {{ universeName() || 'this universe' }} and place them directly
      into {{ sessionName() || 'the selected session' }}.
    </p>

    <div class="character-create-meta">
      <span><strong>Universe:</strong> {{ universeName() || 'Unknown Universe' }}</span>
      <span><strong>Campaign:</strong> {{ campaignName() || 'Unknown Campaign' }}</span>
      <span><strong>Session:</strong> {{ sessionName() || 'Unknown Session' }}</span>
    </div>

    <div class="character-create-grid">
      <label class="form-group">
        <span>Name</span>
        <input
          [ngModel]="characterDraft().name"
          (ngModelChange)="updateDraft('name', $event)"
          placeholder="Enter character name"
          required
        />
      </label>

      <label class="form-group">
        <span>Nickname</span>
        <input
          [ngModel]="characterDraft().nickname"
          (ngModelChange)="updateDraft('nickname', $event)"
          placeholder="Enter character nickname"
          required
        />
      </label>

      <label class="form-group">
        <span>Role</span>
        <input
          [ngModel]="characterDraft().role"
          (ngModelChange)="updateDraft('role', $event)"
          placeholder="Enter character role"
          required
        />
      </label>

      <label class="form-group">
        <span>Type</span>
        <input
          [ngModel]="characterDraft().type"
          (ngModelChange)="updateDraft('type', $event)"
          placeholder="Enter character type"
          required
        />
      </label>
    </div>

    <label class="form-group">
      <span>Image URL</span>
      <input
        [ngModel]="characterDraft().imageUrl"
        (ngModelChange)="updateDraft('imageUrl', $event)"
        placeholder="Optional portrait URL"
      />
    </label>

    <div class="button-row">
      <button
        type="button"
        class="primary-btn"
        [disabled]="!canCreateCharacter()"
        (click)="createCharacter()"
      >
        Create And Join Session
      </button>
      <a class="secondary-btn" [routerLink]="['/sessions']">Back To Sessions</a>
    </div>

    @if (createCharacterError()) {
      <p class="validation-text">{{ createCharacterError() }}</p>
    }
  </section>
}
